import * as React from 'react';
import { useEffect, useState } from "react";
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import {Modal} from "../../../../Modal";
import {FakeCounterSubscribed} from "../../../../FakeCounterSubscribed";
const WebDateTomorrow = () => {
  let [dateState, setDateState] = React.useState();
  React.useEffect(() => {
    let months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
    let webTime = ' в 20:00 (МСК)';
    let now = new Date();
    let lastDayOfMonth = new Date(Date.UTC(now.getFullYear(), now.getMonth()+1, 0));
    function isLastDayOfMonth() {
      let today = now.getDate();
      let lastDay = lastDayOfMonth.getDate();

      if (today === lastDay) {
        return true;
      } else {
        return false;
      }
    }
    function setDate() {
      let webDay = now.getDate()+1;
      let webMonth = now.getMonth();
      let lastDay = isLastDayOfMonth();

      if (!lastDay) { //проверяем время на конец месяца
        setDateState(`${webDay} ${months[webMonth]}${webTime}`)
      } else {
        if (webMonth !== 11) { //если последний день месяца, то проверяем на конец года
          setDateState(`1 ${months[webMonth + 1]}${webTime}`)
        } else {
          setDateState(`1 января ${webTime}`)
        }
      }
    }

    setDate();

  }, [dateState]);

  return (
    <span>{dateState}</span>
  );
}
const Timer = () => {
  //format example "2023-04-25T19:00:00"
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const getTime = () => {
    let now = new Date();
    const time = new Date(Date.UTC(now.getFullYear(), now.getMonth(), `${now.getDate()+1}`, 17) - Date.now());
    if (time > 0) {
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
      setMinutes(Math.floor((time / 1000 / 60) % 60));
    } else {
      setDays(0);
      setHours(0);
      setMinutes(0);
    }
  };
  const getText = (number, text) => {
    if (text === 'days') {
      if (number > 10 && [11, 12, 13, 14].includes(number % 100)) return 'дней';
      let last_num = number % 10;
      if (last_num === 1) return 'день';
      if ([2, 3, 4].includes(last_num)) return 'дня';
      if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'дней';
    } else if (text === 'hours') {
      if (number > 10 && [11, 12, 13, 14].includes(number % 100)) return 'часов';
      let last_num = number % 10;
      if (last_num === 1) return 'час';
      if ([2, 3, 4].includes(last_num)) return 'часа';
      if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'часов';
    } else if (text === 'minutes') {
      if (number > 10 && [11, 12, 13, 14].includes(number % 100)) return 'минут';
      let last_num = number % 10;
      if (last_num === 1) return 'минута';
      if ([2, 3, 4].includes(last_num)) return 'минуты';
      if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'минут';
    }
  };
  useEffect(() => {
    let now = new Date();
    const time = new Date(Date.UTC(now.getFullYear(), now.getMonth(), `${now.getDate()+1}`, 17) - Date.now());
    const interval = setInterval(() => getTime(time), 1000);
    console.log(interval);
    return () => clearInterval(interval);
  });
  return (
    <div className={screen1.timeWrap}>
      <p><span>{days}</span> <span>{getText(days, 'days')}</span></p>
      <p><span>{hours}</span> <span>{getText(hours, 'hours')}</span></p>
      <p><span>{minutes < 10 ? '0' + minutes : minutes}</span> <span>{getText(minutes, 'minutes')}</span></p>
    </div>
  );
};
export const Screen1e = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={screen1.wrapper}>
          <div className={screen1.content}>
            <div className={screen1.time}>
              <WebDateTomorrow/>
            </div>
            <p className={screen1.type}>БЕСПЛАТНЫЙ ВЕБИНАР</p>
            <h1>КАК ВЫУЧИТЬ АНГЛИЙСКИЙ <br/>
              <span>новичку в кратчайшие сроки</span></h1>
            <div className={screen1.gift}>
              <svg width="66" height="63" viewBox="0 0 66 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M33 0L40.7902 24.0639H66L45.6049 38.9361L53.3951 63L33 48.1277L12.6049 63L20.3951 38.9361L0 24.0639H25.2098L33 0Z" fill="#FFD00D"/>
              </svg>
              <div className={screen1.giftTxt}>
                <p>В подарок — тренинг</p>
                <p>«Как запомнить 100 слов на иностранном языке за 2 часа?»</p>
              </div>
            </div>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>
              Занять место и получить подарок
            </button>
            <div className={screen1.timer}>
              <div className={`${screen1.wrap} ${screen1.time}`}>
                <h3>До&nbsp;вебинара осталось:</h3>
                <Timer/>
              </div>
              <div className={`${screen1.wrap} ${screen1.people}`}>
                <h3>Уже записалось:</h3>
                <p>
                  <FakeCounterSubscribed startNum={1547} webId={'kva-e'}/> человек
                </p>
              </div>
            </div>
          </div>
          <div className={screen1.img}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_za_3_mesyaca/union-jack.png" alt=""/>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
